export enum $translations {
  _id = '_id',
  _config = '_config',
  comment = 'comment',
  value = 'value',
  englishName = 'englishName',
  nativeName = 'nativeName',
  locale = 'locale',
  values = 'values',
  configValues = 'configValues',
}

export enum $translationsConfigValue {
  _id = '_id',
  englishName = 'englishName',
  nativeName = 'nativeName',
  isDefault = 'isDefault',
}

export const ENGLISH_ORIGINAL_LOCALE_CODE = 'en-us';
export const ENGLISH_VARIATION_LOCALE_CODE = 'en-us-2';
